import { HttpErrorKind, HttpErrorPage } from '@/pages/errors/HttpError'

/** Rendered at any path no route matches — the 404 kind of the HTTP error family (TO-640). */
export function NotFoundPage() {
	return <HttpErrorPage kind={HttpErrorKind.NotFound} />
}
